import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Drawer, Grid, Hidden, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useUserData } from '../../hooks/useUserData';
import Logo from '../../assets/images/login/logo.png';
import Mobile from './Mobile';
import './styles.scss';

function MenuToolbar() {
  const navigate = useNavigate();
  const { userData } = useUserData();
  const [openMenu, setOpenMenu] = useState(false);
  const urlHome = '/home';

  // useEffect(() => {
  //   if (user) {
  //     console.log('Usuario activo');
  //   } else {
  //     console.log('No hay usuario activo.');
  //   }
  // }, [user]);

  const toggleDrawer = () => {
    setOpenMenu((prev) => !prev);
  };

  // Función para obtener las iniciales del usuario
  const getInitials = (nombre) => {
    if (!nombre) return 'U';
    const words = nombre.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return nombre[0].toUpperCase();
  };

  // Función para obtener el nombre completo
  const getDisplayName = () => {
    if (!userData) return 'Usuario';

    // Si hay nombre y apellido separados
    if (userData.nombre && userData.apellido) {
      return `${userData.nombre} ${userData.apellido}`;
    }
    // Si solo hay nombre
    if (userData.nombre) {
      return userData.nombre;
    }
    // Si hay un campo nombreCompleto
    if (userData.nombreCompleto) {
      return userData.nombreCompleto;
    }
    // Si solo hay email
    if (userData.email) {
      return userData.email;
    }
    return 'Usuario';
  };

  return (
    <>
      <div className="header-toolbar">
        <Grid container alignItems="center" justifyContent="space-between">
          {/* Logo */}
          <Grid item xs={6} md={3} className="logo-wrapper">
            <div className="header-logo-container">
              <img
                src={Logo}
                alt="logo"
                className="logo-header"
                onClick={() => navigate(urlHome)}
              />
            </div>
          </Grid>

          {/* Usuario y menú - Desktop */}
          <Hidden mdDown>
            <Grid item md={9} className="header-right">
              {userData && (
                <div className="header-user">
                  <div className="header-user-info">
                    <span className="header-welcome-text">
                      Bienvenido,
                    </span>
                    <span className="header-user-name">
                      {getDisplayName()}
                    </span>
                  </div>
                  <Avatar className="header-user-avatar">
                    {getInitials(getDisplayName())}
                  </Avatar>
                </div>
              )}
            </Grid>
          </Hidden>

          {/* Menú móvil - Mobile */}
          <Hidden mdUp>
            <Grid item xs={3} className="header-right">
              <MenuIcon className="menu-icon-mobile" style={{ padding: "0" }} onClick={toggleDrawer} />
            </Grid>
          </Hidden>
        </Grid>
      </div>

      {/* Drawer menú móvil */}
      <Drawer anchor="right" open={openMenu} onClose={toggleDrawer}>
        <div className="menu-mobile-drawer">
          <Mobile />
        </div>
      </Drawer>
    </>
  );
}

export default MenuToolbar;